import { BACKEND } from "../variables.js";
import axios from "axios";
const START_SUBSCRIPTION_URL = BACKEND + "/tenantSubscriptions/add";
const BULK_ADD_SUBSCRIPTION_URL = BACKEND + "/tenantSubscriptions/bulkAdd";
const UPDATE_SUBSCRIPTION_URL = BACKEND + "/tenantSubscriptions/update";
const RENEW_SUBSCRIPTION_URL = BACKEND + "/tenantSubscriptions/renew";
const END_SUBSCRIPTION_URL = BACKEND + "/tenantSubscriptions/end";
const DELETE_SUBSCRIPTION_URL = BACKEND + "/tenantSubscriptions/delete";
const END_SUBSCRIPTION_PREVIEW_URL =
  BACKEND + "/tenantSubscriptions/endPreview";
const PAST_CLIENTS_URL = BACKEND + "/tenantSubscriptions/pastClients";
const SAVE_END_REPORT_URL = BACKEND + "/tenantSubscriptions/saveEndReport";
const ADD_PAST_CLIENT_URL = BACKEND + "/tenantSubscriptions/addPastClient";
const END_REPORT_PDF_URL = BACKEND + "/tenantSubscriptions/endReportPdf";
const GET_MY_SUBSCRIPTIONS_URL = BACKEND + "/tenantSubscriptions/my";
const LIST_SUBSCRIPTIONS_BY_HOUSE_URL =
  BACKEND + "/tenantSubscriptions/listByHouse";
const LIST_PAYMENT_LINES_URL = BACKEND + "/tenantSubscriptions/paymentLines";
const GET_SUBSCRIPTION_URL = BACKEND + "/tenantSubscriptions/get/";
const GET_SUBSCRIPTION_DOCUMENTS_URL =
  BACKEND + "/subscriptionDocuments/getBySubscription";
const ADD_SUBSCRIPTION_DOCUMENT_URL = BACKEND + "/subscriptionDocuments/add";
const DELETE_SUBSCRIPTION_DOCUMENT_URL =
  BACKEND + "/subscriptionDocuments/delete";

export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    ["START_SUBSCRIPTION"](state, payload) {
      return axios({
        method: "POST",
        url: START_SUBSCRIPTION_URL,
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    /** Bulk-add one subscription kind to many tenants. Pass { preview: true } in the data
     *  to get counts without writing. */
    ["BULK_ADD_SUBSCRIPTION"](state, payload) {
      return axios({
        method: "POST",
        url: BULK_ADD_SUBSCRIPTION_URL,
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    ["UPDATE_SUBSCRIPTION"](state, payload) {
      return axios({
        method: "POST",
        url: UPDATE_SUBSCRIPTION_URL,
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    ["RENEW_SUBSCRIPTION"](state, payload) {
      return axios({
        method: "POST",
        url: RENEW_SUBSCRIPTION_URL,
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    ["END_SUBSCRIPTION"](state, payload) {
      return axios({
        method: "POST",
        url: END_SUBSCRIPTION_URL,
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    /** Unpaid bills + reason/decision option lists shown before ending a subscription. */
    ["END_SUBSCRIPTION_PREVIEW"](state, payload) {
      return axios({
        method: "POST",
        url: END_SUBSCRIPTION_PREVIEW_URL,
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    /** Ended subscriptions with their exit reports (the Past Clients register). */
    ["GET_PAST_CLIENTS"](state, payload) {
      return axios({
        method: "POST",
        url: PAST_CLIENTS_URL,
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    /** Document an already-ended subscription, or change the decision on its unpaid amount. */
    ["SAVE_END_REPORT"](state, payload) {
      return axios({
        method: "POST",
        url: SAVE_END_REPORT_URL,
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    /** Record a client who left before the house started using the system. */
    ["ADD_PAST_CLIENT"](state, payload) {
      return axios({
        method: "POST",
        url: ADD_PAST_CLIENT_URL,
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    ["GET_END_REPORT_PDF"](state, payload) {
      return axios({
        method: "POST",
        url: END_REPORT_PDF_URL,
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
        responseType: "blob",
      });
    },
    ["DELETE_SUBSCRIPTION"](state, payload) {
      return axios({
        method: "POST",
        url: DELETE_SUBSCRIPTION_URL,
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    ["GET_MY_SUBSCRIPTIONS"](state, payload) {
      return axios({
        method: "POST",
        url: GET_MY_SUBSCRIPTIONS_URL,
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    ["LIST_SUBSCRIPTIONS_BY_HOUSE"](state, payload) {
      return axios({
        method: "POST",
        url: LIST_SUBSCRIPTIONS_BY_HOUSE_URL,
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    ["LIST_PAYMENT_LINES"](state, payload) {
      return axios({
        method: "POST",
        url: LIST_PAYMENT_LINES_URL,
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    ["GET_SUBSCRIPTION"](state, payload) {
      return axios({
        method: "GET",
        url: GET_SUBSCRIPTION_URL + payload.data.subscription_id,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    ["GET_SUBSCRIPTION_DOCUMENTS"](state, payload) {
      return axios({
        method: "POST",
        url: GET_SUBSCRIPTION_DOCUMENTS_URL,
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    ["ADD_SUBSCRIPTION_DOCUMENT"](state, payload) {
      return axios({
        method: "POST",
        url: ADD_SUBSCRIPTION_DOCUMENT_URL,
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    ["DELETE_SUBSCRIPTION_DOCUMENT"](state, payload) {
      return axios({
        method: "POST",
        url: DELETE_SUBSCRIPTION_DOCUMENT_URL,
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
  },
};
